<template>

  <h1 class="Transmision_title">Información Transmisión</h1>

  <p class="text-header">
    Conoce el resumen de tu transmisión de nómina, en caso de que requieras
    descargar la información haz clic en el botón <span><b>Descargar</b></span>
    para tener a tu disposición un archivo Excel con todo el detalle de la
    transmisión.
  </p>

<el-dropdown class="Button_BColorDegradedDownload btn-position">
    <span>           
      <font-awesome-icon
        :icon="['fas', 'download']"
        style="padding-left: 5px"
        size="lg"
        /> Descargar
    </span>
     <template #dropdown>
        <el-dropdown-menu class="menuOpcionesDescarga">         
          <el-dropdown-item
            @click="DescargarArchivoNominaExcel()">
            <font-awesome-icon
              :icon="['fas', 'file-excel']"
              style="color: #1e6e24"
              size="lg"/> Descargar en Excel
          </el-dropdown-item>
          <el-dropdown-item
            @click="DescargarArchivoNomina('xml')">
            <div class="icon-text-container">
              <img
                :src="require('@/assets/img/green-xml.svg')"
                height="21.3"
                width="16"
                alt="Descarga de XML"
              />
              <p class="texto">Descargar en XML</p>
            </div>
          </el-dropdown-item>
          <el-dropdown-item
            @click="DescargarArchivoNomina('pdf')">
              <font-awesome-icon
              :icon="['fas', 'file-alt']"
              style="color: #d12308"
              size="lg"/> Descargar Representación Gráfica
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  
  <a class="btn-back btn-position" @click="GoToSummary()">
    <font-awesome-icon :icon="['fas', 'arrow-left']" size="xs" /> Volver
  </a>

  <Dialog
    v-model:visible="dialogVisible"
    modal
    :closable="false"
    header="Importante"
    :draggable="false"
    id="p-dialog"
    class="error-dialog"
  >
    <img src="../assets/img/Warning.png" width="60" height="60" alt="Alerta" />

    <p v-text="mensajeErrorDescargaArchivo"></p>

    <template #footer>
      <Button class="btnActionPopUp" icon="pi pi-times" @click="CerrarModal" text>← Volver</Button>
    </template>
  </Dialog>

  <TabView ref="tabView" :activeIndex="activeTab">
    <TabPanel header="Trabajador">
      <InformacionTrabajador
        v-if="empleado && detalleNomina"
        :empleado="empleado"
        :detalle="detalleNomina"
        :fechaIngreso="fechaIngreso"
        :fechaAprobacion="fechaAprobacion">
      </InformacionTrabajador>
    </TabPanel>

    <TabPanel header="Liquidación de nómina">
      <LiquidacionNomina
        v-if="nomina && detalleNomina && empleado"
        :empleado="empleado"
        :liquidacion="nomina"
        :detalle="detalleNomina"
        :fechaIngreso="fechaIngreso"
        :fechaAprobacion="fechaAprobacion">
      </LiquidacionNomina>
    </TabPanel>

    <TabPanel header="Otros devengos y deducciones">
      <DeduccionesNomina
        v-if="nomina && detalleNomina && empleado"
        :empleado="empleado"
        :deducciones="nomina"
        :detalle="detalleNomina"
        :fechaIngreso="fechaIngreso"
        :fechaAprobacion="fechaAprobacion">
      </DeduccionesNomina>
    </TabPanel>
  </TabView>
</template>

<script>

import { ref } from "vue";
import router from "@/router";
import { useStore } from "vuex";
import { onMounted } from "vue-demi";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { useMutations } from "@/store/helper";
import "@/assets/sass/views/_PayrollDetail.scss";
import { DescargarArchivo } from "@/helpers/helpers";
import { TabDetail } from "@/models/Payroll/Enums";
import DeduccionesNomina from "@/components/DetalleNomina/DeduccionesNomina.vue";
import LiquidacionNomina from "@/components/DetalleNomina/LiquidacionNomina.vue";
import InformacionTrabajador from "@/components/DetalleNomina/InformacionTrabajador.vue";
import Dialog from "primevue/dialog";

export default {
  components: {
    TabView,
    TabPanel,
    InformacionTrabajador,
    LiquidacionNomina,
    DeduccionesNomina,
    Dialog,
  },
  setup() {

    const tabView = ref();
    const tabs = TabDetail;
    const store = useStore();
    const activeTab = ref(tabs.Trabajador);
    const { setStateLoading } = useMutations(["setStateLoading"]);
    const detalleNomina = ref();
    const nomina = ref({});
    const empleado = ref({});
    const fechaIngreso = ref("");
    const fechaAprobacion = ref("");
    const dialogVisible = ref(false);
    const mensajeErrorDescargaArchivo = ref("No es posible descargar el archivo, inténtalo de nuevo, si el error persiste contáctanos.");

    const CerrarModal = () => {
      dialogVisible.value = false;
    };

    function GoToSummary() {
      router.push({
        name: "SummaryTransmission",
      });
    }
    
    function ObtenerNominaEmpleado() {
      setStateLoading(true);

      let entradaConsulta = {
        token: localStorage.getItem("Tokensin"),
        detalleNominaId: store.state.DetalleNomina.DetalleNominaId,
      };

      store
        .dispatch("ObtenerNominaEmpleado", entradaConsulta)
        .then((response) => {
          empleado.value = response.data.empleado;
          detalleNomina.value = response.data.detalleNomina;

          const nominaEmpleado = JSON.parse(
            detalleNomina.value.jsonNomina
          );

          nomina.value = nominaEmpleado;
          fechaIngreso.value = nomina.value.AdmissionDate;
          fechaAprobacion.value = detalleNomina.value.fechaConsultaDIAN;

          setStateLoading(false);
        })
        .catch((error) => {
          if (error.response.status == 404) {
            GoToSummary();
          }
          setStateLoading(false);
          console.log(error.request.response);
        });
    }

    function DescargarArchivoNominaExcel() {
      setStateLoading(true);

      let entradaConsulta = {
        token: localStorage.getItem("Tokensin"),
        detalleNominaId: store.state.DetalleNomina.DetalleNominaId,
      };

      store
        .dispatch("DescargarArchivoNominaEmpleado", entradaConsulta)
        .then((response) => {
          if (response.data != null && response.data.archivo != null){
            DescargarArchivo(
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              response.data.archivo,
              response.data.nombre
            );
          } else {
            dialogVisible.value = true;
          }
          setStateLoading(false);
        })
        .catch((error) => {
          setStateLoading(false);
          console.log(error.request.response);
        });
    }
    function DescargarArchivoNomina(formatoArchivo) {
      setStateLoading(true);

      let entradaConsulta = {
        token: localStorage.getItem("Tokensin"),
        detalleNominaId: store.state.DetalleNomina.DetalleNominaId,
        formatoArchivo: formatoArchivo
      };

      store
        .dispatch("DescargarArchivoNominaIndividualAprobada", entradaConsulta)
        .then((response) => {
          if(response.data != null) 
          {
            if (response.data.archivoBase64 != null) 
            {
              DescargarArchivo(
                `application/${formatoArchivo}`,
                response.data.archivoBase64,
                response.data.nombreArchivo
              );
            }
            else
            {
              if (response.data.mensajeError != null){
                mensajeErrorDescargaArchivo.value = response.data.mensajeError;
              }
              dialogVisible.value = true;
            }
          } 
          else 
          {
            dialogVisible.value = true;
          }         
          setStateLoading(false);
        })
        .catch((error) => {
          setStateLoading(false);
          console.log(error.request.response);
        });
    }
    onMounted(() => {
      ObtenerNominaEmpleado();
    });

    return {
      nomina,
      empleado,
      detalleNomina,
      GoToSummary,
      activeTab,
      tabView,
      DescargarArchivo,
      DescargarArchivoNominaExcel,
      DescargarArchivoNomina,
      fechaAprobacion,
      fechaIngreso,
      dialogVisible,
      CerrarModal,
      mensajeErrorDescargaArchivo
    };
  },
};
</script>
